import { defineRule, configure } from 'vee-validate'
import { all } from '@vee-validate/rules'
import { localize, setLocale } from '@vee-validate/i18n'

Object.keys(all).forEach((rule) => {
  defineRule(rule, all[rule])
})

// defineRule('test', (value, params) => {
//   return value || true
// })

configure({
  generateMessage: localize({
    en: {
      messages: {
        required: (field) => field + ' should not be empty.',
        min: (field, args) => field + ' should be more than ' + args + ' alphamunerics.',
        max: (field, args) => field + ' should be less than ' + args + ' alphamunerics.',
        digits: (field, args) => field + ' should be ' + args + ' digit',
        min_value: (field, args) => field + ' should be more than ' + args,
        max_value: (field, args) => field + ' should be less than ' + args,
        integer: (field) => field + ' should be integer',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' should be ' + args,
        regex: (field) => 'The ' + field + ' is incorrect.',
        email: () => 'Please enter right email format.'
      }
    },
    ja: {
      messages: {
        required: (field) => field + ' should not be empty.',
        min: (field, args) => field + ' should be more than ' + args + ' alphamunerics.',
        max: (field, args) => field + ' should be less than ' + args + ' alphamunerics.',
        digits: (field, args) => field + ' should be ' + args + ' digit',
        min_value: (field, args) => field + ' should be more than ' + args,
        max_value: (field, args) => field + ' should be less than ' + args,
        integer: (field) => field + ' should be integer',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' should be ' + args,
        regex: (field) => 'The ' + field + ' is incorrect.',
        email: () => 'Please enter right email format.'
      }
    }
  })
})
setLocale('en')
